export default __webpack_public_path__ + "static/SR USA - Sobre sulfito - Declaración-73fa28e7a174dbd8678996df585177c7.pdf";